export const headerZIndex = ['', // zero index
  'filtersMobile',
  'searchBox',
  'mobileMenuOverlay',
  'mobileMenu',
  'accountDropdown',
  'chainsSidebarOverlay',
  'chainsSidebar',
] as const;
